import Loader from "react-loader-spinner";
import { useState, useRef } from "react";
import { Button, Col, Modal, Row, Table } from "react-bootstrap";
import { Check2, DashCircle, Search } from "react-bootstrap-icons";
import { getInvoiceSerialHistory } from "../store/api/GetAllProduct";
import BihamtaTable from "../../Components/BihamtaTable";
import { invoiceTypes } from "../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory } from "@fortawesome/free-solid-svg-icons";

const ModalInvoiceSerials = (props) => {
    const searchData = useRef({});
    const { popData, setPopData, productGrouppingType } = props;
    const { show, setData, filterFaulty } = popData;
    const [list, getDataList] = useState();
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف" },
        { colName: "ProductHolder", colTitle: "مارک کالا", justInMobile: true, showCondition: () => Number(productGrouppingType) !== 1 },
        { colName: "ProductName", colTitle: (Number(productGrouppingType) !== 1 ? "نوع کالا" : "نام کالا"), justInMobile: true },
        { colName: "ProductModel", colTitle: "مدل کالا", justInMobile: true },
        { colName: "ProductSerial", colTitle: "سریال کالا", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colName: "UnitPrice", colTitle: "قیمت واحد", colType: "currency" },
        { colName: "InvoiceTypeName", colTitle: "نوع فاکتور" },
    ]
    function close() {
        if (setData)
            setData(null);
        setPopData({
            show: false
        })
    }
    function search(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        getInvoiceSerialHistory(searchData.current.SerialNumber ?? "", filterFaulty, getDataList);
    }
    function select(item) {
        delete item.e;
        if (setData) {
            if (item.InvoiceTypeStr === invoiceTypes.Disassembly) {
                item.DisassemblyDetailID = item.DetailID;
            }
            setData(item);
        }
        setPopData({
            show: false
        })
    }
    return (
        <Modal show={show} size="lg" onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faHistory} size="lg" />&nbsp;
                    تاریخچه سریال فاکتورها
                </span>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <Row>
                    <Col md={5} className="form-group mt-0">
                        <input className="form-control" onChange={e => searchData.current.SerialNumber = e.target.value} onKeyDown={search} style={{fontFamily:"Dark-Sans", fontSize:"11.5px"}}/>
                        <Button className="btn-input-tiny" style={{ top: "9px", left: "14px" }} onClick={search}><Search size={20} /></Button>
                    </Col>
                </Row>
                <BihamtaTable columns={tableCols} dataList={list} fixedHeight rowClick={select} />
                <Button variant="danger" className="group-Btn" onClick={close}><DashCircle size={15} />&nbsp; انصراف</Button>
            </Modal.Body>
        </Modal>
    )
}
export default ModalInvoiceSerials;
